export function whatsappNumber(value) {
  let digits = String(value || '').replace(/\D/g, '');
  if (/^(809|829|849)\d{7}$/.test(digits)) digits = `1${digits}`;
  return /^\d{8,15}$/.test(digits) ? digits : '';
}

export function whatsappLink(value) {
  if (!value) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
    if (url.hostname === 'wa.me') {
      const number = whatsappNumber(url.pathname);
      if (!number) return null;
      url.pathname = `/${number}`;
      return url.href;
    }
    if (['api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) {
      const number = whatsappNumber(url.searchParams.get('phone'));
      if (!number) return null;
      url.searchParams.set('phone', number);
      return url.href;
    }
    return null;
  } catch {
    const number = whatsappNumber(value);
    return number ? `https://wa.me/${number}` : null;
  }
}
